import React, { Component } from 'react';
import MemberHeader from '../../components/MemberHeader';
import ModuleContainer from '../../components/ModuleContainer';
import { Card, Col, Row, Button } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { memberOperations } from '../Members/state';
import { profileImageStyle } from '../../../utils/common';
import { Image as NativeImage } from 'react-native';
import { REST_SERVICE_URL_ROOT } from '../../../config/settings';
import '../../../includes/custom/css/paypal.css'
import PaypalButtons from "./component/PaypalButtons";
import axios from 'axios';
import { paypalOperations } from './state'
import Error404 from '../Errors/404';
import { SUCCESS,
    GET,
    POST,
    SUBSCRIPTION_ACTIVE, 
    STATUS_CODE_SUCCESS, 
    NO, 
    YES, 
    SECONDARY, 
    SUCCESS_BUTTON, 
    LEAGUE_PASS_PAYMENT, 
    PAYMENT_TYPE_LEAGUES_PASS,
    PAYMENT_TYPE_MEMBERSHIP } from '../../../utils/constants';
import { PAYPAL_BASE_URL, PAYPAL_CLIENT_ID, PAYPAL_CLIENT_SECRET } from '../../../config/settings';
import { PAYPAL_SUBSCRIPTION, PAYPAL_ORDER, AUTH_API } from './state/apiRoutes'
import { isNullOrUndefined } from 'util';
import moment from 'moment';
import Overflow from 'react-overflow-indicator';
import { FaAngleDoubleDown } from 'react-icons/fa'
import ConfirmationModal from '../../components/ConfirmationModal';
import { CANCEL_SUBSCRIPTION, ACTIVATE_SUBSCRIPTION, SUBSCRIPTION_TITLE } from '../../../utils/messages';
import PaypalLoading from './PaypalLoading';
import AdminError from '../Errors/AdminError';
import ReactDOM from 'react-dom';

class PaypalScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            countries: [],
            loaded: false,
            showPaypal: false,
            radioValue: 'recurring',
            success: false,
            accessToken: '',
            orderDetails: null,
            subscriptionDetails: null,
            isSubscribing: false,
            paymentDetails: null,
            paypalDetails: null,
            userDetails: null,
            userId: "",
            industryList: [],
            isLoading: false,
            canScrollDown: false,
            showCancelModal: false,
            showActivateModal: false,
        };

        axios.defaults.baseURL = PAYPAL_BASE_URL;
        let service = axios.create();
        service.interceptors.request.use(function (config) {
            try {
                config.headers.common['Content-Type'] = 'application/json';

            } catch{
                console.log("Unauthorized");
            }
            return config;
        })

        this.service = service

    }

    componentDidMount() {
        let cryptUserId = this.props.match.params.userId
        this.props.encryptDecryptd(cryptUserId, false).then((result) => {
            if (!isNullOrUndefined(result)) {
                this.setState({
                    userId: result.data
                }, () => {
                    this.getIndustryList()
                    this.getAccessToken()
                })
            }
        })
    }

    getIndustryList = () => {

        this.props.getIndustryList().then((response) => {
            if (!isNullOrUndefined(response)) {
                if (SUCCESS === response.status) {
                    this.setState({ industryList: response.data })
                }
            }
        })
    }

    getAccessToken = () => {
    this.service.request({
            method: POST,
            url: AUTH_API,
            auth: {
                username: PAYPAL_CLIENT_ID,
                password: PAYPAL_CLIENT_SECRET,
            },
            params: {
                grant_type: "client_credentials",
            },
            headers: {
                "Accept": "application/json",
                "Accept-Language": "en_US",
                "content-type": "application/x-www-form-urlencoded"
            }
        }).then((response) => {
            this.service.interceptors.request.use(function (config) {
                try {
                    config.headers.common['Authorization'] = "Bearer " + response.data.access_token;

                } catch{
                    console.log("Unauthorized");
                }
                return config;
            })
            this.setState({ accessToken: response.data.access_token }, () => {
                this.getUserPayment()
            })
        });
    }

    getUserPayment = () => {
        this.props.getUserRecurringPayment(this.state.userId, this.props.match.params.paymentType).then((result) => {

            if (!isNullOrUndefined(result)) {
                this.setState({ userDetails: result.data.userModel, paypalDetails: result.data.paypalModel, isLoading: true },
                    () => result.data.paypalModel ? (1 === result.data.paypalModel.isRecurring ? this.getSubscriptionDetails() : this.getOrderDetails()) : this.setState({ isLoading: false }))
            }
            else {
                ReactDOM.render(
                    <AdminError />,
                    document.getElementById('root')
                );
            }
        })
    }

    getSubscriptionDetails = () => {
        let data = this.state.paypalDetails
        this.service.request({
            method: GET,
            url: `${PAYPAL_SUBSCRIPTION}/${data.transactionCode}`,
        }).then((response) => {
            if (null !== response) {
                this.setState({ subscriptionDetails: response.data, isLoading: false }, () => {
                    if (response.data.status === SUBSCRIPTION_ACTIVE) {
                        this.setState({ isSubscribing: true })
                    }
                })
            }

        })
    }

    cancelSubscription = () => {
        let data = this.state.paypalDetails
        this.service.request({
            method: POST,
            url: `${PAYPAL_SUBSCRIPTION}/${data.transactionCode}/suspend`,
            data: {
                "reason": "DEACTIVE SUBSCRIPTION"
            }
        }).then((response) => {
            if (STATUS_CODE_SUCCESS === response.status) {
                this.setState({ isSubscribing: false, isLoading: true }, () => {
                    this.getSubscriptionDetails()
                    this.toggleCancelModal();
                })
            }
        })
    }

    reactivateSubscription = () => {
        let data = this.state.paypalDetails
        this.service.request({
            method: POST,
            url: `${PAYPAL_SUBSCRIPTION}/${data.transactionCode}/activate`,
            data: {
                "reason": "Reactivate subscription"
            }
        }).then((response) => {
            if (STATUS_CODE_SUCCESS === response.status) {
                this.setState({ isSubscribing: true, isLoading: true }, () => {
                    this.getSubscriptionDetails()
                    this.toggleActivateModal()
                })
            }
        })
    }

    getOrderDetails = () => {
        let data = this.state.paypalDetails
        this.service.request({
            method: GET,
            url: `${PAYPAL_ORDER}/${data.transactionCode}`,
        }).then((response) => {
            if (null !== response) {
                this.setState({ orderDetails: response.data, isLoading: false })
            }
        }

        )
    }


    showPaypalButtons = () => {
        this.setState({ showPaypal: true });
    };

    handleSuccess = (data) => {
        let paymentModel = {
            isRecurring: data.isRecurring,
            transactionCode: data.transactionCode,
            userId: this.state.userId,
            paymentType: PAYMENT_TYPE_MEMBERSHIP
        }
        this.props.insertPayment(paymentModel).then((response) => {
            if (SUCCESS === response.status) {
                this.getUserPayment()
            }
        }
        )
    }

    handleLeaguePassPaymentSuccess = (data) => {

        let paymentModel = {
            isRecurring: 0,
            transactionCode: data.transactionCode,
            userId: this.state.userId,
            paymentType: PAYMENT_TYPE_LEAGUES_PASS
        }

        this.props.insertPayment(paymentModel).then((response) => {
            if (SUCCESS === response.status) {
                this.getUserPayment()
            }
        }
        )
    }

    getIndustryName = () => {
        return this.state.industryList.filter((data) => { return data.industryId === this.state.userDetails.industryId })[0].industryName
    }

    renderPaymentDetails = () => {
        const { subscriptionDetails, orderDetails, userDetails } = this.state
        if (subscriptionDetails || orderDetails) {
            if (null !== subscriptionDetails) {
                return (
                    <div className="main">
                        <div style={{ marginTop: 15 }}>
                            {subscriptionDetails.status === SUBSCRIPTION_ACTIVE ? <p className={"paypal-text-title"}> Transaction Completed!</p> : <p className={"paypal-text-title"}> Be a subscribed member again!</p>} <br />
                            <p style={{ fontWeight: "500", fontSize: "14px" }}>Subscription Details</p>
                            <p className={"paypal-text-details"}>Billing ID : {subscriptionDetails.id}</p>
                            <p className={"paypal-text-details"}>Date of Transaction : {moment(subscriptionDetails.create_time).format("LLL")}</p>
                            <p className={"paypal-text-details"}>Next Billing Date : {moment(subscriptionDetails.billing_info.next_billing_time).format("LLL")}</p>
                            <p className={"paypal-text-details"}>Status : {subscriptionDetails.status}</p>
                            <hr />
                            <p className={"paypal-text-details"}>Payment Sender : {subscriptionDetails.subscriber.name.given_name + " " + subscriptionDetails.subscriber.name.surname}</p>
                            <p className={"paypal-text-details"}>Email Address : {subscriptionDetails.subscriber.email_address}</p>
                        </div >
                    </div>
                )
            }

            else {
                return (
                    <div className="main">
                        <div style={{ marginTop: 15 }}>
                            <p className={"paypal-text-title"}> Transaction Completed!</p><br />
                            <p style={{ fontWeight: "500", fontSize: "14px" }}>Payment Details</p>
                            <p className={"paypal-text-details"}>Transaction ID : {orderDetails.purchase_units[0].payments.captures[0].id}</p>
                            <p className={"paypal-text-details"}>Total Amount : {orderDetails.purchase_units[0].amount.value + " " + orderDetails.purchase_units[0].amount.currency_code}</p>
                            <p className={"paypal-text-details"}>Date of Transaction : {moment(orderDetails.create_time).format("LLL")}</p>
                            <p className={"paypal-text-details"}>Subscription End Date : {isNullOrUndefined(userDetails.subscriptionEndDate) ? moment(orderDetails.create_time).add("year", 2).format("LL") : moment(userDetails.subscriptionEndDate).format("LL")}</p>
                            <p className={"paypal-text-details"}>Status : {orderDetails.status}</p>
                            <hr />
                            <p className={"paypal-text-details"}>Payment Sender : {orderDetails.payer.name.given_name + " " + orderDetails.payer.name.surname}</p>
                            <p className={"paypal-text-details"}>Email Address : {orderDetails.payer.email_address}</p>
                        </div>
                    </div>)
            }
        }
        else {
            return (
                <div className="main">
                    <div style={{ marginTop: 15 }}>
                        <p style={{ fontWeight: "500", fontSize: "14px" }}>Subscription Details</p>
                        <p className={"paypal-text-details"}>Subscription Status : {userDetails.isSubscribed === 1 ? "ACTIVE" : "INACTIVE"}</p>
                        <p className={"paypal-text-details"}>Subcription End Date: {moment(userDetails.subscriptionEndDate).format("LLL")}</p>

                    </div >
                </div>
            )
        }
    }
    toggleCancelModal = () => {
        this.setState({ showCancelModal: !this.state.showCancelModal })
    }

    toggleActivateModal = () => {
        this.setState({ showActivateModal: !this.state.showActivateModal })
    }

    renderReactivate = () => {
        return (< div >
            <Card>
                <h2 style={{ fontWeight: "bold" }}> REACTIVATE MEMBERSHIP ?</h2>
                {this.renderPaymentDetails()}
                <Button variant="success" type={"button"} className="subscription-button" onClick={() => this.toggleActivateModal()}>ACTIVATE SUBSCRIPTION</Button>
            </Card>
            {!this.state.userDetails.isSubscribed &&
                <Card>
                    <PaypalButtons {...this.props} handleSuccess={this.handleSuccess} reactivate />
                </Card>
            }

        </div>)
    }

    renderUserSubscribed = () => {
        const { subscriptionDetails } = this.state

        return (
            subscriptionDetails ?
                (this.state.isSubscribing ?
                    //RECURRING SUBSCRIBED
                    (<Card>
                        <h2 style={{ fontWeight: "bold" }}>PAYMENT SUCCESSFUL!</h2>
                        {this.renderPaymentDetails()}
                        {/* this.cancelSubscription() */}
                        <Button variant="danger" className="subscription-button" type={"button"} onClick={() => this.toggleCancelModal()}>CANCEL SUBSCRIPTION</Button>
                    </Card>)
                    : (
                        subscriptionDetails ?
                            this.renderReactivate()
                            :
                            <div className={"container-member"}>
                                <p className={"container-content"} style={{ fontSize: 20, fontWeight: "500" }}>Be a Member of SHS-ADC Alumni Association</p>
                                <p className={"paypal-text-details"}>Membership fee of 500 PHP</p>
                                <div style={{ marginTop: 24 }}>
                                    <PaypalButtons handleSuccess={this.handleSuccess} />
                                </div>
                            </div>
                    )
                ) :
                //ONE-TIME PAID
                <Card>
                    <h2 style={{ fontWeight: "bold" }}>PAYMENT SUCCESSFUL!</h2>
                    {this.renderPaymentDetails()}
                </Card>

        )
    }

    renderPayMembership = () => {
        
        const { subscriptionDetails } = this.state

        return (
            subscriptionDetails && !this.state.isSubscribing ?
                this.renderReactivate()
                :
                <div className={"container-member"}>
                    <p className={"container-content"} style={{ fontSize: 20, fontWeight: "500" }}>Be a Member of SHS-ADC Alumni Association</p>
                    <p className={"paypal-text-details"}>Membership fee of 500 PHP</p>
                    <div style={{ marginTop: 24 }}>
                        <PaypalButtons handleSuccess={this.handleSuccess} />
                    </div>
                </div>
        )
       
    }

    renderPayLeaguePass = () => {
        
        const { userDetails, orderDetails } = this.state
        
        return (
            userDetails && userDetails.hasLeaguePass === 0 ?
            <div className={"container-member"}>
                <p className={"container-content"} style={{ fontSize: 20, fontWeight: "500" }}>Grab your League Pass now!</p>
                <p className={"paypal-text-details"}>League Pass fee of {LEAGUE_PASS_PAYMENT} PHP</p>
                <div style={{ marginTop: 24 }}>
                    <PaypalButtons handleSuccess={this.handleLeaguePassPaymentSuccess} 
                        paymentType={PAYMENT_TYPE_LEAGUES_PASS}
                    />
                </div>
            </div>
            :
            (  
            orderDetails ?
            (
            <div className="main">
                <div style={{ marginTop: 15 }}>
                    <p className={"paypal-text-title"}> Your League Pass is already active!</p><br />
                    <p style={{ fontWeight: "500", fontSize: "14px" }}>Payment Details</p>
                    <p className={"paypal-text-details"}>Transaction ID : {orderDetails.purchase_units[0].payments.captures[0].id}</p>
                    <p className={"paypal-text-details"}>Total Amount : {orderDetails.purchase_units[0].amount.value + " " + orderDetails.purchase_units[0].amount.currency_code}</p>
                    <p className={"paypal-text-details"}>Date of Transaction : {moment(orderDetails.create_time).format("LLL")}</p>
                    {/* <p className={"paypal-text-details"}>Subscription End Date : {isNullOrUndefined(userDetails.subscriptionEndDate) ? moment(orderDetails.create_time).add("year", 2).format("LL") : moment(userDetails.subscriptionEndDate).format("LL")}</p> */}
                    <p className={"paypal-text-details"}>Status : {orderDetails.status}</p>
                    <hr />
                    <p className={"paypal-text-details"}>Payment Sender : {orderDetails.payer.name.given_name + " " + orderDetails.payer.name.surname}</p>
                    <p className={"paypal-text-details"}>Email Address : {orderDetails.payer.email_address}</p>
                </div>
            </div>
            )
            :
            (
            <div className="main">
                <div style={{ marginTop: 15 }}>
                    <p className={"paypal-text-title"}> Your League Pass is already active!</p><br />
                </div>  
            </div>
            )
            )
        )
       
    }


    render() {
        const { userDetails } = this.state
        let paymentType = this.props.match.params.paymentType

        if (null === userDetails) {
            return <PaypalLoading />
        }
        return (
            <div>
                <MemberHeader/>
                <Overflow style={{ maxHeight: 500 }} onStateChange={state => this.setState({ canScrollDown: state.canScroll.down })}>
                    <Overflow.Content>
                        <ModuleContainer style={{ border: "1px solid #fff" }}>
                            <Row>
                                <Col md={{ span: 4, offset: 1 }}>
                                    <Card style={{ height: "100%" }}>
                                        <h3>Member Information</h3>
                                        <div>
                                            <NativeImage
                                                source={{ uri: `${REST_SERVICE_URL_ROOT}/user/image/${userDetails.userId}?${this.state.imageHash}` }}
                                                style={profileImageStyle}
                                                resizeMode={"cover"}

                                            />
                                        </div>
                                        <br />
                                        <Row>
                                            <Col ><p className="space-between-data"><b>Name:</b> </p></Col>
                                            <Col >{userDetails.firstName + " " + userDetails.lastName}</Col>
                                        </Row>
                                        <Row>
                                            <Col ><p className="space-between-data"><b>Gender:</b> </p></Col>
                                            <Col >{userDetails.gender}</Col>
                                        </Row>
                                        <Row>
                                            <Col ><p className="space-between-data"><b>Batch Year:</b> </p></Col>
                                            <Col >{userDetails.batchYear}</Col>
                                        </Row>
                                        <Row>
                                            <Col ><p className="space-between-data"><b>Contact Number:</b> </p></Col>
                                            <Col >{userDetails.contactNumber}</Col>
                                        </Row>
                                        <Row>
                                            <Col ><p className="space-between-data"><b>Company:</b> </p></Col>
                                            <Col >{userDetails.company}</Col>
                                        </Row>
                                        <Row>
                                            <Col ><p className="space-between-data"><b>Industry:</b> </p></Col>
                                            <Col >{this.getIndustryName()}</Col>
                                        </Row>
                                        <Row>
                                            <Col ><p className="space-between-data"><b>Designation:</b> </p></Col>
                                            <Col >{userDetails.occupation}</Col>
                                        </Row>
                                        <p className="space-between-data"><b>Company Description: </b> </p>
                                        {userDetails.companyDescription}
                                    </Card>
                                </Col>

                                <Col md={6}>
                                    <Card style={{ height: "100%" }}>
                                        {this.state.isLoading ? <h4>Loading...</h4>
                                            :
                                            PAYMENT_TYPE_LEAGUES_PASS === paymentType ? this.renderPayLeaguePass() :
                                            userDetails && userDetails.isSubscribed ?
                                                this.renderUserSubscribed()
                                                : 
                                                this.renderPayMembership()
                                        }
                                    </Card>
                                </Col>
                            </Row>
                        </ModuleContainer>
                    </Overflow.Content>
                </Overflow>
                {this.state.canScrollDown && <div style={{ position: "absolute", bottom: 8, right: 12, zIndex: 888, opacity: 0.8 }}>
                    <div className="info-scroll">
                        <p className="info-text">View Payment Section</p>
                        <FaAngleDoubleDown color="white" size={18} /></div>
                </div>
                }
                <ConfirmationModal
                    show={this.state.showCancelModal}
                    toggleModal={this.toggleCancelModal}
                    title={SUBSCRIPTION_TITLE}
                    message={CANCEL_SUBSCRIPTION}
                    subMessage={"Note: Amount already paid will not be refunded."}
                    modalButtons={[
                        { label: NO, onClick: this.toggleCancelModal, variant: SECONDARY },
                        { label: YES, onClick: this.cancelSubscription, variant: SUCCESS_BUTTON }
                    ]}
                />
                <ConfirmationModal
                    show={this.state.showActivateModal}
                    toggleModal={this.toggleActivateModal}
                    title={SUBSCRIPTION_TITLE}
                    message={ACTIVATE_SUBSCRIPTION}
                    modalButtons={[
                        { label: NO, onClick: this.toggleActivateModal, variant: SECONDARY },
                        { label: YES, onClick: this.reactivateSubscription, variant: SUCCESS_BUTTON }
                    ]}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        formInputs: state.payments.paymentForm
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        listOfCountries: memberOperations.listOfCountries,
        getUserRecurringPayment: paypalOperations.getUserRecurringPayment,
        encryptDecryptd: paypalOperations.encryptDecryptId,
        insertPayment: paypalOperations.insertPayment,
        getIndustryList: memberOperations.getIndustryList,

    },
    dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(PaypalScreen);
